<template>
    <div class="sidebar__section sidebar__section--vertical-padding sidebar__section--border-bottom ui-overflow-hidden" v-if="poi.bigImages">
        <div class="poi-pictures">
            <template v-if="poi.bigImages">
                <Swiper class="poi-pictures__image-slider" 
                    :options="sliderOptions" 
                    v-if="poi.bigImages.length > 1"
                >
                    <SwiperSlide v-for="bigImage in poi.bigImages" :key="bigImage.url">
                        <div :style="{'background-image': `url(${bigImage.url})`}" class="poi-pictures__image"/>
                    </SwiperSlide>
                    <div class="swiper-pagination smr-swiper__pagination" slot="pagination"></div>
                    <icon class="smr-swiper__arrow smr-swiper__arrow--prev" slot="button-prev" :size="16"><IconChevronLeft/></icon>
                    <icon class="smr-swiper__arrow smr-swiper__arrow--next" slot="button-next" :size="16"><IconChevronRight/></icon>
                </Swiper>
                <div v-else :style="{'background-image': `url(${poi.bigImages[0].url})`}" class="poi-pictures__image"/>
            </template>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconChevronLeft from '@/components/icons/IconChevronLeft.vue'
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
export default {
    components: {
        Icon,
        IconChevronLeft,
        IconChevronRight,
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            sliderOptions: {
                spaceBetween: 8,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    prevEl: '.smr-swiper__arrow--prev',
                    nextEl: '.smr-swiper__arrow--next',
                }
            }
        }
    },
}
</script>

<style lang="scss">
.poi-pictures {
    &__image-slider {
        overflow: visible;   
    }
    &__image {
        position: relative;
        background-position: center;
        background-size: cover;
        background-color: $color-black-003;
        border-radius: $standard-border-radius;
        
        &:not(:last-child) {
            margin-bottom: 16px;
        }
        &::after {
            content: '';
            display: block;
            padding-bottom: 56.25%;
        }
    }
}
</style>